import React from "react";
import EditRoles from "./edit-roles";

const EditRolesComponent = ({
  accountId,
  roles,
  roleRates,
  tags,
  isPartner
}) => {
  return (
    <EditRoles
      accountId={accountId}
      roles={roles}
      roleRates={roleRates}
      tags={tags}
      isPartner={isPartner}
    />
  );
};

export default EditRolesComponent;
